<template>
  <div :class="[className, { 'disabled':disabled }, { 'is-dragging':isDraggingFileOver }]" class="file-input-group"
    @click="inputClick"
    @dragenter.prevent
    @dragover.prevent="handleDragOver"
    @dragleave="handleDragLeave"
    @drop.prevent="handleDropFile"
  >
    <input type="file" :id="fileId" :name="name" @change="handleSelectFile" ref="input-file" :disabled="disabled">
    <span v-if="!isLoading" class="file-name" :class="{'text-cinza-4':showingPlaceholder}">{{ fileName }}</span>
    <div v-else class="spinner-border text-maino-blue" role="status"></div>
    <button :class="btnClass" :disabled="disabled">{{ buttonText }}</button>
  </div>
</template>

<script>
export default {
  emits: ['update:modelValue'],
  inheritAttrs: false,
  props: {
    modelValue: {
      required: false,
      type: Object,
    },
    fileId: {
      type: String,
      required: false,
    },
    name: {
      type: String,
      required: false ,
    },
    accept: {
      type: String,
      default: '',
    },
    className: {
      type: String,
      required: 'false',
    },
    placeholder: {
      type: String,
      required: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    btnClass: {
      type: String,
      default: 'btn btn-outline-green',
    },
    buttonText: {
      type: String,
      default: 'Buscar',
    },
  },
  data() {
    return {
      file: this.buildFile(),
      loading: false,
      dragging: false,
      unwatch: ()=>{},
    }
  },
  computed: {
    fileName() {
      if(this.isDraggingFileOver) return 'Solte o arquivo aqui'
      if(this.file.name) return this.file.name

      return this.placeholder
    },
    isLoading() {
      return this.loading
    },
    showingPlaceholder() {
      return this.file.name ? false : true
    },
    isDraggingFileOver() {
      return this.dragging
    },
  },
  methods: {
    handleSelectFile(ev) {
      const file = ev.target.files[0] || {}

      this.uploadFile(file)
    },
    uploadFile(file) {
      const { name, type } = file
      const fileExtention = name?.split('.').pop()

      if(file instanceof File) {
        this.loading = true

        let reader = new FileReader()
        reader.onload = () => {
          this.file = {
            name, type, fileExtention,
            buffer: reader.result,
            isUploaded: true,
            inputFile: file,
          };

          this.loading = false;
          this.$emit('update:modelValue', this.file)
        };
        reader.readAsArrayBuffer(file)
      }
    },
    inputClick() {
      if(this.disabled) return;

      this.$refs["input-file"].click();
    },
    buildFile() {
      return {
        name: "",
        size: 0,
        type: "",
        fileExtention: "",
        buffer: ()=>{},
        isUploaded: false,
        inputFile: {},
      }
    },
    handleDragOver() {
      this.dragging = true
    },
    handleDragLeave() {
      this.$nextTick(() => {
        this.dragging = false
      })
    },
    handleDropFile(ev) {
      const file = ev.dataTransfer.files[0] || {}

      this.uploadFile(file, true)
      this.dragging = false
    },
  },
  mounted() {
    this.unwatch = this.$watch('modelValue', (newValue)=> {
      if (!newValue) {
        this.file = this.buildFile()
        this.$refs["input-file"].value = null
        return;
      }
      this.file = newValue
    })
  },
  beforeUnmount() {
    this.unwatch()
  },
}
</script>
